import { Common } from './common';
import {
  DiagnosticResults,
  RetrieveAppointmentDiagnostics,
} from './models/diagnostics';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async retrieveAppointments(
    args: RetrieveAppointmentDiagnostics,
  ): Promise<DiagnosticResults> {
    const url = this.common.constructPath(
      `/diagnostics/appointments-results`,
      args,
    );
    return this.common.getJSON(url);
  }
}
